import React, { SVGProps } from 'react'
const SvgCopy = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      d="M17.692 17.049h2.616V4.434H7.692v2.615H17c.382 0 .692.31.692.692v9.308Zm-11.384-10V3.741c0-.382.31-.692.692-.692h14c.382 0 .692.31.692.692v14c0 .383-.31.693-.692.693h-3.308v3.307c0 .383-.31.693-.692.693H3a.692.692 0 0 1-.692-.693v-14c0-.382.31-.692.692-.692h3.308ZM3.692 8.434v12.615h12.616V8.434H3.692Z"
    />
  </svg>
)
export default SvgCopy
